import React, { useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { CaptchContext } from "../../common/CaptchContext";
import axios from "axios";

const BriefConversationForm = () => {
  const { gre } = useContext(CaptchContext);
  const initialValues = {
    name: "",
    address: "",
    subject: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    address: Yup.string().email("Invalid email").required("Email is required"),
    subject: Yup.string().required("Subject is required"),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    gre(async () => {
      try {
        await PostConversation(values, resetForm);
      } catch (error) {
        console.error("Error submitting the form:", error);
      }
    });
  };

  const PostConversation = async (values, resetForm) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/case-study-conversations`,
        // `${process.env.REACT_APP_API_URL}/api/case-study-conversations`,
        {
          Name: values.name,
          Email: values.address,
          Organization_name_and_message: values.subject,
          token: process.env.REACT_APP_BACKEND_TOKEN_POST
        },
        {
          headers: {
            Authorization: process.env.REACT_APP_BACKEND_TOKEN,
          },
        }
      );
      if (response.status === 200) {
        resetForm();
        alert("Your enquiry submited successfully.");
      } else {
        alert("Something went wrong!");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="row ttm-quote-form clearfix">
          <div className="col-sm-6 col-md-6">
            <div className="form-group">
              <Field
                name="name"
                type="text"
                className="form-control bg-white"
                placeholder="Your Name*"
              />
              <ErrorMessage
                name="name"
                component="div"
                className="text-danger"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6">
            <div className="form-group">
              <Field
                name="address"
                type="email"
                className="form-control bg-white"
                placeholder="Email Address*"
              />
              <ErrorMessage
                name="address"
                component="div"
                className="text-danger"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-12">
            <div className="form-group">
              
              <Field
              as="textarea"
                name="subject"
                type="text"
                className="form-control bg-white"
                placeholder="Your organization's name and a brief message*"
              />
              <ErrorMessage
                name="subject"
                component="div"
                className="text-danger"
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="text-left">
              <button
                type="submit"
                className="mt-3 ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor"
                disabled={isSubmitting}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default BriefConversationForm;
